import { render, staticRenderFns } from "./ModalAssesment.vue?vue&type=template&id=6824b4f6&scoped=true"
import script from "./ModalAssesment.vue?vue&type=script&lang=js"
export * from "./ModalAssesment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6824b4f6",
  null
  
)

export default component.exports